import CheckIn from './check-in';

export default CheckIn;
